import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import css from '@styled-system/css';
import propTypes from '@styled-system/prop-types';
import styled from 'styled-components';
import { color, space, system, textStyle, typography } from 'styled-system';
const wrapped = "\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n";
const lineClampStyle = "\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow-y: hidden;\n";
const hyphens = "\n  hyphens: auto;\n";
export const TypographyBase = styled.div.withConfig({
  displayName: "TypographyBase",
  componentId: "sc-hrr11b-0"
})(["&&&{", " ", " ", " ", " ", " ", " ", " ", "}"], typography, color, textStyle, space, p => p.hyphens && hyphens, p => p.wrapped && wrapped, p => p.lineClamp && "".concat(lineClampStyle, "-webkit-line-clamp: ").concat(p.lineClamp, ";"), system({
  userSelect: true
}));
TypographyBase.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, propTypes.color), propTypes.typography), propTypes.textStyle), propTypes.space);
export const SuperTitle = styled(TypographyBase).withConfig({
  displayName: "SuperTitle",
  componentId: "sc-hrr11b-1"
})(css({
  fontWeight: 900,
  fontSize: [11, 11, 12],
  lineHeight: 4,
  color: 'text.primary'
}));
SuperTitle.defaultProps = {
  as: 'h1'
};
export const Title = styled(SuperTitle).withConfig({
  displayName: "Title",
  componentId: "sc-hrr11b-2"
})(css({
  fontSize: [9, 9, 10],
  lineHeight: 3
}));
export const SecondaryTitle = styled(SuperTitle).withConfig({
  displayName: "SecondaryTitle",
  componentId: "sc-hrr11b-3"
})(css({
  fontSize: [7, 7, 8],
  lineHeight: 2
}));
SecondaryTitle.defaultProps = {
  as: 'h2'
};
export const TertiaryTitle = styled(SecondaryTitle).withConfig({
  displayName: "TertiaryTitle",
  componentId: "sc-hrr11b-4"
})(css({
  fontSize: [5, 5, 6]
}));
TertiaryTitle.defaultProps = {
  as: 'h3'
};
export const KeyTag = styled(TypographyBase).withConfig({
  displayName: "KeyTag",
  componentId: "sc-hrr11b-5"
})(css({
  fontWeight: 900,
  fontSize: 1,
  lineHeight: 2,
  color: 'text.secondary'
}));
KeyTag.defaultProps = {
  as: 'h4',
  textStyle: 'caps'
};
export const Tag = styled(KeyTag).withConfig({
  displayName: "Tag",
  componentId: "sc-hrr11b-6"
})(css({
  fontWeight: 400,
  color: 'text.primary'
}));
Tag.defaultProps = {
  as: 'h5'
};
export const StrongText = styled(TypographyBase).withConfig({
  displayName: "StrongText",
  componentId: "sc-hrr11b-7"
})(css({
  fontWeight: 700,
  fontSize: [3, 3, 4],
  lineHeight: 2,
  marginY: 0,
  color: 'text.primary'
}));
StrongText.defaultProps = {
  as: 'p'
};
export const Text = styled(StrongText).withConfig({
  displayName: "Text",
  componentId: "sc-hrr11b-8"
})(css({
  fontWeight: 400
}));
export const SecondaryText = styled(Text).withConfig({
  displayName: "SecondaryText",
  componentId: "sc-hrr11b-9"
})(css({
  fontSize: [1, 1, 2],
  lineHeight: [1, 1, 2],
  color: 'text.secondary'
}));
export const Alert = styled(StrongText).withConfig({
  displayName: "Alert",
  componentId: "sc-hrr11b-10"
})(css({
  fontSize: [1, 1, 2],
  lineHeight: [2, 3, 2]
}));
Alert.defaultProps = {
  as: 'span'
};
export const DividerText = styled(TypographyBase).withConfig({
  displayName: "DividerText",
  componentId: "sc-hrr11b-11"
})(css({
  fontWeight: 400,
  fontSize: 1,
  lineHeight: [0, 0, 2],
  color: 'text.caption'
}));
DividerText.defaultProps = {
  as: 'span',
  textStyle: 'caps'
};
export const Caption = styled(TypographyBase).withConfig({
  displayName: "Caption",
  componentId: "sc-hrr11b-12"
})(css({
  fontWeight: 400,
  fontSize: [0, 0, 1],
  lineHeight: 0,
  color: 'text.caption'
}));
SuperTitle.propTypes = Title.propTypes = SecondaryTitle.propTypes = TertiaryTitle.propTypes = KeyTag.propTypes = Tag.propTypes = StrongText.propTypes = Text.propTypes = SecondaryText.propTypes = Alert.propTypes = DividerText.propTypes = Caption.propTypes = TypographyBase.propTypes;